// Compiled at 2026-10-07T06:21:14.844Z
// Auto-generated by Lowgile
import * as LowgileDataUtil from "@lg/shared";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Toolbox, Toolbox as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
import { BoInfoSymbol, OnAfterCodeLoad, HasChangedInternallySymbol } from "@lg/shared";
// Auto-generated by Lowgile
import { jsonClass, jsonProperty } from "@sumbricht/json-class-serializer";
import { proxySignal, ProxySignal, signal, computed, Signal } from "../../signals.js";
import { HasSignalProperties } from "@lg/shared";
import { immerable } from "immer";
import { DataLoader } from "@lg/shared";
import { Subject } from "rxjs";
import { z } from "zod";
import { AppContext } from "@lg/ng-shared";
import { ChangeDetectorRef } from "@angular/core";

const θdataLoader =
    new DataLoader(() => Customers.loadInternal(), entryList => {
        Customers.θentryList.set(entryList)
        Customers.θonEntryListUpdated()
    }, { doCache: true, expireAfterMs: 0 })
    ;

// Auto-generated by Lowgile
export class Customers {
    readonly [BoInfoSymbol] = Object.freeze({
        boType: "StaticEntity" as const,
        editablePropertyNames: ["id"] as const,
        computedPropertyNames: ["name", "isParent"] as const,
        allPropertyNames: ["id", "name", "isParent"] as const,
        propertyNamesOfInterest: [] as const,
    });
    readonly [HasSignalProperties] = true;
    readonly [HasChangedInternallySymbol] = new Subject<void>();
    readonly θid: ProxySignal<Customers.Id | null>;
    static readonly Id = String;
    static ids: Customers.Id[] = [] as any;
    static idsAndDisplayValues: Record<Customers.Id, string> = {} as any;
    static θentryList = signal<Customers.Entry[] | undefined>(this.θgetStaticEntryList());
    static θentryMap = computed(() => {
        const objEntries = this.θentryList()?.map(e => [e.id, e]) ?? []
        return Object.freeze(Object.fromEntries(objEntries))
    });
    static θchoicesCache = new Map<string, Sys.Types.Choice[]>();
    static θfilteredCache = new Map<string, Signal<Customers.Entry[]>>();
    readonly θhasOthers = false;
    static readonly $displayProperty = 'id';
    [immerable] = true;
    readonly θname = computed(() => {
        const id = this.θid()
        return id !== null ? Customers.getEntryMap()[id]?.name : undefined
    });
    readonly θisParent = computed(() => {
        const id = this.θid()
        return id !== null ? Customers.getEntryMap()[id]?.isParent : undefined
    });
    readonly $isOther = false;

    static get [BoInfoSymbol]() {
        return Customers[BoInfoSymbol]
    }

    get __type(): 'Toolbox.Customers' {
        return 'Toolbox.Customers'
    }

    set __type(_) {
    }

    static get __type(): 'Toolbox.Customers' {
        return 'Toolbox.Customers'
    }

    static set __type(_) {
    }

    @jsonProperty()
    get id(): Customers.Id | null {
        return this.θid()
    }

    set id(id: Customers.Id | Customers | null) {
        if (id !== null && typeof id == 'object') { id = id.id }



        this.θid.set(id as Customers.Id | null)
        this[HasChangedInternallySymbol].next()
    }

    get __boType(): 'StaticEntity' {
        return 'StaticEntity'
    }

    static get __boType(): 'StaticEntity' {
        return 'StaticEntity'
    }

    get ids(): Customers.Id[] {
        return Customers.ids
    }

    get idsAndDisplayValues(): Record<Customers.Id, string> {
        return Customers.idsAndDisplayValues
    }

    get $displayValue(): string {
        return this.$isOther ? (this as any).$other : String((this as any)[Customers.$displayProperty])
    }

    get name() {
        return this.θname()
    }

    get isParent() {
        return this.θisParent()
    }

    constructor(idOrObject: Customers.Id | Customers | null = null) {
        const { id } = this.θtoIdAndOther(idOrObject)
        this.θid = proxySignal(id)

    }

    getEntryList(filters?: { entryProperty: string, values: any[] }[]): Customers.Entry[] {
        return This.Customers.getEntryList(filters)
    }

    static getEntryList(filters?: { entryProperty: string, values: any[] }[]): Customers.Entry[] {
        if (filters) {
            const key = JSON.stringify(filters)
            let filteredList = this.θfilteredCache.get(key)
            if (!filteredList) {
                filteredList = computed(() => this.θentryList()?.filter(entry => filters.every(filter => filter.values.includes(entry[filter.entryProperty]))) ?? [])
                this.θfilteredCache.set(key, filteredList)
            }

            return filteredList()
        }

        return this.θentryList()
    }

    static getEntryMap() {
        return this.θentryMap()
    }

    static getEntry(id: Customers.Id) {
        const entryMap = this.getEntryMap()
        return entryMap[id]
    }

    static getChoices(labelColumn: keyof Customers.Entry = '$displayValue'): Sys.Types.Choice[] {
        if (labelColumn == "$displayValue") labelColumn = Customers.$displayProperty
        let options = this.θchoicesCache.get(labelColumn)
        if (!options) {
            const entryList = this.getEntryList() ?? []
            options = entryList.map(entry => ({ id: entry.id, label: String(entry[labelColumn]), $isOther: false }))
            this.θchoicesCache.set(labelColumn, options)
        }

        return options
    }

    static async load(forceReload = false) {
        if (forceReload) {
            this.θentryList.set(await θdataLoader.forceReloadAndGetData())
        } else {
            this.θentryList.set(await θdataLoader.waitAndGetValidData())
        }

        this.θonEntryListUpdated()
        return this.θentryList()
    }

    static async loadInternal(): Promise<Customers.Entry[]> {
        async function getDynamicEntries() {
            try {
                return ExecutionService.executeMethodAndReturnData<any[]>('StaticEntity', 'Toolbox', 'Customers', undefined, 'getEntryList', [])
            } catch (err: any) {
                console.error('Error loading dynamic entries for Toolbox.Customers:', err)
                return []
            }

        }

        const dynamicEntryList = await getDynamicEntries()
        this.θchoicesCache.clear()
        return LowgileDataUtil.createReadonlyProxy(true, [...this.θgetStaticEntryList(), ...dynamicEntryList])
    }

    toJSON() {
        return this.id
    }

    $clone() {
        return new Customers(this.id)
    }

    $equals(other: any) {
        if (this.id !== other?.id) return false

        return true
    }

    θtoPlainObject() {
        return this.id
    }

    θtoIdAndOther(idOrObject: Customers.Id | Customers | null) {
        if (idOrObject && typeof idOrObject == 'object') {
            return { id: idOrObject.id }

        } else {
            return { id: idOrObject as Customers.Id | null, otherValue: '' }

        }
    }

    θupdate(idOrObject: Customers.Id | Customers) {
        const { id } = this.θtoIdAndOther(idOrObject)
        this.θid.set(id)

    }

    static θonEntryListUpdated() {
        this.ids = this.getEntryList().map(e => e.id)
        this.idsAndDisplayValues = Object.fromEntries(this.getEntryList().map(e => [e.id, e.$displayValue] as const)) as Record<Customers.Id, string>
        AppContext.resolve(ChangeDetectorRef).detectChanges()
    }

    static async θafterCodeLoad() {
        return this.load().catch(err => {
            console.log('Could not load entries of StaticEntity Toolbox.Customers yet:', err.message)
            //throw err
        })
    }

    static $getSchema() {
        return z.string()
    }

    $getSchema() {
        return z.string()
    }

    static θgetStaticEntryList() {
        return Object.freeze([

        ] as Customers.Entry[]) as Customers.Entry[]
    }
}
jsonClass('Toolbox.Customers')(Customers)

export const CustomersθId = String;

export type CustomersθId = string;

export namespace Customers {
    export type Id = string

    export interface Entry {
        id: Customers.Id;
        name: string;
        isParent: boolean;
        $displayValue?: string;
    }
}
Sys.Language.languageChanged$.subscribe(() => Customers.load(true))
